/**
 * @file: Card.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The shared lifted surface for every section body on the lead-detail screen.
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { LD, cardShadowStyle } from '../leadDetailKit';

export const Card = ({ children }: { children: React.ReactNode }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        backgroundColor: LD.surface,
        borderRadius: rpx(14),
        paddingHorizontal: rpx(16),
        paddingVertical: rpx(6),
        marginBottom: rpx(8),
        ...cardShadowStyle(rpx),
      }}
    >
      {children}
    </View>
  );
};
